/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BankSchool } from "./BankSchool";
import type { BankViewerCurriculumDto } from "./BankViewerCurriculumDto";
import type { BankViewerIntentInfoDto } from "./BankViewerIntentInfoDto";
import type { BankViewerItemDto } from "./BankViewerItemDto";
import type { BankViewerStepInfoDto } from "./BankViewerStepInfoDto";
export type BankViewerTemplateDto = {
  key: string;
  exam: string;
  school: BankSchool;
  unitKey: string;
  unitName: string;
  intent: BankViewerIntentInfoDto;
  /**
   * 이 문제틀의 단계 — 단계 없는 문제틀은 null
   */
  step: BankViewerStepInfoDto | null;
  solveLabel: string;
  status: BankViewerTemplateDto.status;
  /**
   * 발문 틀
   */
  stemTemplate: string | null;
  curriculum: BankViewerCurriculumDto | null;
  /**
   * 출처 데이터 요약 — 예: 학평 1회, 평균 오답률 30%
   */
  sourceSummary: string | null;
  /**
   * seed 순(엔진 버전이 여럿이면 새 버전부터)
   */
  items: Array<BankViewerItemDto>;
};
export namespace BankViewerTemplateDto {
  export enum status {
    PUBLISHED = "published",
    GATED = "gated",
    RETIRED = "retired",
  }
}
